
export default {
    name: 'TaxBaseForm',
    data() {
        return {
            action: '',
            tax: {
                taxId: '',
                name: '',
                value: ''
            }
        }
    },
    methods: {
        setAction(actionParam) {
            this.action = actionParam;
        },
        clearTax() {
            this.$router.push('/taxes');
        },
        async handleBtnSave() {
            await this.$store.dispatch(this.action, this.tax);
            this.clearTax();
        },
        handleBtnCancel() {
            this.clearTax();
        } 
    },

}